var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.entity
        ? [
            _vm.withoutLink
              ? _c("span", [_vm._v(_vm._s(_vm.entity.name))])
              : [
                  _vm.worker
                    ? [
                        _vm.newPage
                          ? [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    target: "_blank",
                                    href: `?r=redesign#/personal-employee/${
                                      _vm.worker.id
                                    }/${_vm.link ? _vm.link : "summary"}`,
                                  },
                                },
                                [_vm._v(" " + _vm._s(_vm.worker.name) + " ")]
                              ),
                            ]
                          : [
                              _vm.worker
                                ? _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        target: "_blank",
                                        to: {
                                          name: "personal-employee-summary",
                                          params: { id: _vm.worker.id },
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.worker.name) + " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                      ]
                    : [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.user.name
                                ? _vm.user.name
                                : _vm.user.username
                                ? _vm.user.username
                                : ""
                            )
                          ),
                        ]),
                      ],
                ],
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }